@use 'sass:map';
@use '@helsenorge/designsystem-react/scss/spacers' as spacers;
@import '@helsenorge/designsystem-react/scss/breakpoints';

.language-picker-wrapper {
  display: flex;
  justify-content: end;
  margin-bottom: spacers.getSpacer(m);

  @media screen and (min-width: map.get($grid-breakpoints, md)) {
    margin-bottom: spacers.getSpacer(l);
  }
}
